import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
	SectionHeading,
	Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import Img1 from "images/img1.png";
import Img2 from "images/img2.png";
import Img3 from "images/img3.png";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto pt-0 md:pt-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 md:h-auto relative`;
const TextColumn = styled(Column)((props) => [
	tw`md:w-7/12 mt-16 md:mt-0`,
	props.textOnLeft
		? tw`md:mr-12 lg:mr-16 md:order-first`
		: tw`md:ml-12 lg:ml-16 md:order-last`,
]);
const ImageColumnAlt = tw(
	Column
)`md:w-5/12 flex-shrink-0 md:h-auto relative`;
const TextColumnAlt = styled(Column)((props) => [
	tw`md:w-7/12 mt-0`,
	props.textOnLeft
		? tw`md:ml-12 lg:ml-16 order-first md:order-last`
		: tw`md:mr-12 lg:mr-16 order-last md:order-first`,
]);

const Image = styled.div((props) => [
	`background-image: url("${props.imageSrc}");`,
	tw`rounded bg-contain object-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
	SectionHeading
)`mt-4 font-black text-left text-2xl sm:text-3xl lg:text-4xl text-center md:text-left leading-tight flex flex-wrap`;
const Description = tw.p`mt-4 text-left md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
const Statistic = tw.div`text-left sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-secondary-500 tracking-wide`;
const Key = tw.div`font-medium text-primary-700`;

const PrimaryButton = tw(
	PrimaryButtonBase
)`mt-8 md:mt-10 text-sm inline-block mx-auto md:mx-0`;

const DecoratorBlob = styled(SvgDotPattern)((props) => [
	tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

export default ({
	subheading = "Our Track Record",
	heading = <></>,
	description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
	primaryButtonText = "Learn More",
	primaryButtonUrl = "https://timerse.com",
	imageSrc = Img1,
	imageCss = tw`rounded-lg bg-contain h-96`,
	imageContainerCss = null,
	imageDecoratorBlob = false,
	imageDecoratorBlobCss = null,
	imageInsideDiv = true,
	statistics = null,
	textOnLeft = false,
}) => {
	// The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
	//Change the statistics variable as you like, add or delete objects
	const defaultStatistics = [
		{
			key: "Clients",
			value: "2282+",
		},
		{
			key: "Projects",
			value: "3891+",
		},
		{
			key: "Awards",
			value: "1000+",
		},
	];

	if (!statistics) statistics = defaultStatistics;

	return (
		<Container>
			<TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
				<ImageColumn css={imageContainerCss}>
					{imageInsideDiv ? (
						<Image imageSrc={Img1} css={imageCss} />
					) : (
						<img src={Img1} css={imageCss} alt="" />
					)}
					{imageDecoratorBlob && (
						<DecoratorBlob css={imageDecoratorBlobCss} />
					)}
				</ImageColumn>
				<TextColumn textOnLeft={textOnLeft}>
					<TextContent>
						{/* {subheading && <Subheading>{subheading}</Subheading>} */}
						<Heading>
							Innovation<span tw="text-primary-500">|</span>
							Creativity<span tw="text-primary-500">|</span>
							Learning
						</Heading>
						<Description>
							AIeVidya tends to make learning fun by igniting
							curious young minds with 21st-century cutting-edge
							technology innovation and nurturing creative design
							thinking through practical hands-on learning to pave
							the way for their success in the future.
						</Description>
						{/* <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics> */}
						{/* <PrimaryButton as="a" href={primaryButtonUrl}>
              {primaryButtonText}
            </PrimaryButton> */}
					</TextContent>
				</TextColumn>
			</TwoColumn>

			<TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
				<TextColumnAlt>
					<TextContent>
						{/* {subheading && <Subheading>{subheading}</Subheading>} */}
						<Heading>
							Explore<span tw="text-primary-500">|</span>Program
							<span tw="text-primary-500">|</span>Experiment
						</Heading>
						<Description>
							Our program enhances students' critical thinking, problem solving, teamwork, exploration and experimentation with the
							world of new possibilities of S.T.E.M (Science, Technology, Engineering, Math).
						</Description>
					</TextContent>
				</TextColumnAlt>
				<ImageColumnAlt css={imageContainerCss}>
					{imageInsideDiv ? (
						<Image imageSrc={Img2} css={imageCss} />
					) : (
						<img src={Img2} css={imageCss} alt="" />
					)}
					{imageDecoratorBlob && (
						<DecoratorBlob css={imageDecoratorBlobCss} />
					)}
				</ImageColumnAlt>
			</TwoColumn>
			<TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
				<ImageColumn css={imageContainerCss}>
					{imageInsideDiv ? (
						<Image imageSrc={Img3} css={imageCss} />
					) : (
						<img src={Img3} css={imageCss} alt="" />
					)}
					{imageDecoratorBlob && (
						<DecoratorBlob css={imageDecoratorBlobCss} />
					)}
				</ImageColumn>
				<TextColumn textOnLeft={textOnLeft}>
					<TextContent>
						<Heading>
							Learn<span tw="text-primary-500">|</span>
							Educate<span tw="text-primary-500">|</span>
							Grow
						</Heading>
						<Description>
							Our program helps students, teachers, and parents to
							learn how AI technologies work to educate and spread
							awareness of future technologies and foster growth.
						</Description>
					</TextContent>
				</TextColumn>
			</TwoColumn>
		</Container>
	);
};
